import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as server from 'js/hooks/auth/server';
import { setCookie } from 'js/utils/cookie.util';
import { useFormatter } from 'js/hooks/useFormatter';
import { LOGGED_IN_USER_STATUS } from 'js/app/hooks/auth/constants';
import { useLoginRequest } from 'js/hooks/auth/hooks/useLoginRequest';
import { userSetAttributesAction } from 'js/hooks/user/store/actions';

/* core, added userName (line 31) */
export const useLoginBySessionToken = () => {
    const request = useLoginRequest();
    const dispatch = useDispatch();
    const formatter = useFormatter();

    return useCallback(async (userName, pasSessionToken) => {
        const response = await server.login({ ...request, userName, sessionToken: pasSessionToken });
        const playerSessionInfoResponse = await server.getPlayerSessionInfo();

        const playerSessionInfo = playerSessionInfoResponse?.data?.parameters || [];
        const rootSessionStartTime = playerSessionInfo?.find(param => param.key === 'rootSessionStartTime')?.value || '';
        const { sessionToken, previousLoginTime, sessionTokenExpirationTime } = response?.data || {};
        const sessionStartTime = Number(formatter.parseImsDate(rootSessionStartTime)) || Date.now();

        setCookie(LOGGED_IN_USER_STATUS, sessionStartTime, {
            path: '/',
            expires: new Date(sessionTokenExpirationTime).toUTCString()
        });

        dispatch(userSetAttributesAction({
            sessionToken,
            pasSessionToken,
            sessionStartTime,
            previousLoginTime,
            sessionTokenExpirationTime,

            // buzz
            userName
        }));

        return response;
    }, [request, dispatch, formatter]);
};
